import React from 'react';
import { clinicFacts, contactData } from './data';

const Placowki = () => {
  return (
    <div className="pethelp-page">
      <section className="pethelp-hero">
        <div className="pethelp-two-column">
          <div>
            <div className="pethelp-eyebrow">Ogólnopolska sieć</div>
            <h1 className="pethelp-title">
              Placówki dostępne tam, gdzie ich potrzebujesz.
            </h1>
            <p className="pethelp-lead">
              Sieć Pethelp obejmuje lecznice w całej Polsce, a aktualna lista
              partnerów jest publikowana na stronie operatora i regularnie się
              rozszerza.
            </p>
          </div>
          <div className="pethelp-card">
            <h5>Aktualna lista placówek</h5>
            <p className="pethelp-muted">
              Lista jest utrzymywana przez Pethelp i może zmieniać się w czasie.
              Najbezpieczniej korzystać z bieżącej wersji opublikowanej przez
              operatora programu.
            </p>
            <a
              href={contactData.clinics}
              target="_blank"
              rel="noopener noreferrer"
              className="pethelp-cta">
              Zobacz listę placówek
            </a>
          </div>
        </div>
      </section>

      <section className="pethelp-card mt-4">
        <ul className="pethelp-points">
          {clinicFacts.map((fact) => (
            <li key={fact}>{fact}</li>
          ))}
        </ul>
      </section>

      <section className="pethelp-highlight mt-4">
        Jeśli na liście brakuje preferowanej lecznicy, Pethelp zachęca do
        zgłoszenia placówki do potencjalnej współpracy. Zgłoszenie można
        przesłać na adres{' '}
        <a href={`mailto:${contactData.email}`}>{contactData.email}</a>.
      </section>

      <section className="pethelp-map-card pethelp-card">
        <img
          src="/tvp/pethelp-image9.png"
          alt="Mapa placówek Pethelp w Polsce"
          className="pethelp-map"
        />
      </section>
    </div>
  );
};

export default Placowki;
